export const LOGIN_ADMIN_SUCCESS = "admin:loginsuccess";
export const LOGIN_ADMIN_ERROR = "admin:loginerror";
export const LOGIN_ADMIN_REQUEST = "admin:loginrequest";
export const FORGETPASSWORD_SUCCESS = "admin:forgetpasswordsuccess";
export const FORGETPASSWORD_ERROR = "admin:forgetpassworderror";